import { render, staticRenderFns } from "./ClientPhoneBtnCopy.vue?vue&type=template&id=7b781cdc&scoped=true&"
import script from "./ClientPhoneBtnCopy.vue?vue&type=script&lang=js&"
export * from "./ClientPhoneBtnCopy.vue?vue&type=script&lang=js&"
import style0 from "./ClientPhoneBtnCopy.vue?vue&type=style&index=0&id=7b781cdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b781cdc",
  null
  
)

export default component.exports